<template>
  <label class="table-searchbar">
    <IconMagnify color="grey" class="table-searchbar__icon" />
    <input
      v-model="searchTerm"
      type="text"
      class="table-searchbar__input"
      @input="search"
    />
  </label>
</template>

<script>
  import _ from 'lodash';
  import IconMagnify from '~/components/icon/IconMagnify.vue';

  export default {
    name: 'TableSearchbar',
    components: {
      IconMagnify,
    },
    data: () => ({
      searchTerm: '',
    }),
    methods: {
      search: _.debounce(function searchOnType() {
        this.$emit('search', this.searchTerm);
      }, 500),
    },
  };
</script>

<style lang="scss" scoped>
  .table-searchbar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 6px;
    margin: 0;

    border: 1px solid #a7a9ab;
    border-radius: 4px;

    width: 100%;
    max-width: 300px;

    &__icon {
    }
    &__input {
      border: none !important;
      outline: none !important;
      padding: 0 !important;
      min-height: 0 !important;
    }
  }
</style>
